import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import {
  inspectionWorkspaceLinks,
  isInspectionSidebarLinkActive,
} from "./navigation";

export default function InspectionSidebar() {
  const { pathname } = useLocation();
  return (
    <aside className="piers-admin-sidebar piers-inspection-sidebar">
      <nav aria-label="Inspection Workspace">
        <h2>Inspection Workspace</h2>
        {inspectionWorkspaceLinks.map(([to, icon, label]) => (
          <NavLink
            key={to}
            to={to}
            data-tour={
              to === "/review-tasks"
                ? "review-tasks-nav"
                : to === "/engagements/list"
                ? "engagement-nav"
                : undefined
            }
            className={() =>
              isInspectionSidebarLinkActive(pathname, to) ? "active" : ""
            }
          >
            <FeatherIcon icon={icon} />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
